import { useQuery } from '@tanstack/react-query'
import { getImageById, getImagesByIds } from 'api/image'

export const useImageById = (imageId: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['image', imageId],
        queryFn: () => getImageById(imageId),
    })

    return { data, isLoading, error }
}

export const useImagesByIds = (imageIds: string[]) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['images', imageIds],
        queryFn: () => getImagesByIds(imageIds),
    })

    return { images: data, isLoading, error }
}
